@if (!contentLoaded) {
  <ngx-skeleton-loader count="10" [theme]="{ height: '50px' }"></ngx-skeleton-loader>
}
@if (contentLoaded) {
  <div class="card">
    <!-- <p-toast></p-toast> -->
  <p-table #dt [value]="
      allUserList
        | paginate
          : {
              itemsPerPage: pageData.pageSize,
              currentPage: pageData.pageNumber,
              totalItems: pageData.totalItems
            }
    " [rows]="allUserList.length" [paginator]="false" [globalFilterFields]="['first_name', 'contact', 'external_id']"
    [tableStyle]="{ 'min-width': 'auto' }" [rowHover]="true" dataKey="id" currentPageReportTemplate="Showing {first} to {last} of {{
      allUserList.length
    }} entries" [showCurrentPageReport]="true" (onSort)="sortColumn($event)">
    <ng-template pTemplate="caption">
      <!-- <div class="searchField">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          (input)="dt.filterGlobal($event.target.value, 'contains')"
          placeholder="Search Associates"
          />
        </span>
      </div> -->
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <!-- <th style="width: 4rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th> -->
      @if (role != 'SuperAdminRead') {
        <th scope="col">
          <div class="form-check form-check-sm form-check-custom check form-check-solid me-3">
            <input class="form-check-input" type="checkbox" data-kt-check="true" (change)="deleteUser('all')" />
          </div>
        </th>
      }
      <th scope="col" pSortableColumn="firstname">
        NAME/PHONE NUMBER
        <p-sortIcon field="firstname"></p-sortIcon>
      </th>
      <th scope="col" pSortableColumn="vendor">
        VENDOR/USER ROLE
        <p-sortIcon field="vendor"></p-sortIcon>
      </th>
      <th scope="col" pSortableColumn="createdAt">
        JOINING DATE
        <p-sortIcon field="createdAt"></p-sortIcon>
      </th>
      <th scope="col" pSortableColumn="lastLoginDate">
        LAST LOGIN DATE
        <p-sortIcon field="lastLoginDate"></p-sortIcon>
      </th>
      <th scope="col">STATUS</th>
      <th scope="col">ACTION</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-user let-rowIndex="rowIndex">
    <tr>
      <!-- <td>
      <p-tableCheckbox [value]="product"></p-tableCheckbox>
    </td> -->
    @if (role != 'SuperAdminRead') {
      <th scope="row">
        <div class="form-check form-check-sm form-check-custom form-check-solid check me-3">
          <input class="form-check-input" type="checkbox" data-kt-check="true" (change)="deleteUser('seperate')"
            [(ngModel)]="checkedState[rowIndex]" />
          </div>
        </th>
      }
      <td class="d-flex align-items-center">
        <div class="user-symbol overflow-hidden me-3">
          <div class="w-100">
            {{ user.firstname.trim().charAt(0) }}
          </div>
        </div>
        <div class="d-flex flex-column">
          <span class="username font-weight-bold">{{ user.firstname }} {{ user.lastname }}</span>
          <span class="usermobile font-weight-bold">{{
            user.mobile ? "+91 " + user.mobile : "-"
          }}</span>
        </div>
      </td>
      <td>
        <div class="d-flex flex-column">
          <span class="uservendor">{{
            user.organizationname ? user.organizationname : "-"
          }}</span>
          <span class="userrole">{{ user.role ? user.role : "-" }}</span>
        </div>
      </td>
      <td>
        <span class="userjoiningdate">{{
          user.createdAt ? (user.createdAt | date : "medium") : "-"
        }}</span>
      </td>
      <td>
        <span class="userlogindate">{{
          user.lastLoginDate ? (user.lastLoginDate | date : "medium") : "-"
        }}</span>
      </td>
      @if (!user.approved && !user.deleted) {
        <td>
          <span class="badge badge-bg-warning userpending">Pending</span>
        </td>
      }
      @if (user.approved && !user.deleted) {
        <td>
          <span class="badge badge-bg-success useractive">Active</span>
        </td>
      }
      @if (user.deleted) {
        <td>
          <span class="badge badge-bg-danger userinactive">Inactive</span>
        </td>
      }
      @if (
        !!user.approved &&
        !(user.approved && !user.deleted) &&
        !user.deleted
        ) {
        <td class="noStatus">
          -
        </td>
      }
      <td class="mat-cell action text-center" (mouseover)="onHover(rowIndex)" (mouseout)="clear()"
        (click)="navigatetoEditPage(user._id)">
          <img [src]="
              hoveredIndex === rowIndex
                ? '../../../../assets/images/action-on-hover.svg'
                : '../../../../assets/images/action-normal.svg'
            " style="cursor: pointer" />
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" style="text-align: center; border: none">
          <div style="margin: 10px 0; font-size: 13px">
            No Users available
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
}

@if (allUserList.length > 0) {
  <div class="pagination-section my-pagination">
    <pagination-controls (pageChange)="setCurrentPageNumber($event)" [nextLabel]="pageControl.nextLabel"
      [previousLabel]="pageControl.previousLabel" [responsive]="pageControl.responsive"
    [autoHide]="pageControl.autoHide"></pagination-controls>
  </div>
}